import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';

@Component({
  selector: 'xmed-procedure-field-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    XmedicalUiModule
  ],
  templateUrl: './procedure-field-renderer.component.html',
  styleUrl: './procedure-field-renderer.component.scss'
})
export class ProcedureFieldRendererComponent {
  control = input.required<ReportControl>();

  valueChanged = output<void>();

  onValueChanges(): void {
    this.valueChanged.emit();
  }
}
